import { useAuthContext } from "src/auth/AuthContext";
import { useParams } from "react-router-dom";
import FundMoveForm from "./FundMoveForm";

const FundMoveView = () => {
    const { user } = useAuthContext();
    const { id } = useParams();
    return (
        <FundMoveForm
            fundMoveId={parseInt(id ?? "-1")}
            organizationId={user.data.organizationId}
            onSubmit={_entry => Promise.resolve()}
            viewOnly={true}
            header="Ansicht"
        />
    );
};

export default FundMoveView;
